import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CmsComponent from '../../components/CmsComponent';
import { CONTENT_FRAGMENT_NAME } from '../../constants/analyticsNames';
import { CONTENT_FRAGMENT } from '../../constants/cmsResourceTypes';
const ContentFragment = ({ deviceBreakpoints, breakpointClasses, fragmentData, position, uniqueId, }) => (React.createElement("section", { className: classNames(breakpointClasses), id: uniqueId, "data-testid": "content-fragment" },
    React.createElement(CmsComponent, { component: Object.assign(Object.assign({}, fragmentData), { deviceBreakpoints }), position: position })));
ContentFragment.displayName = CONTENT_FRAGMENT_NAME;
ContentFragment.resourceType = CONTENT_FRAGMENT;
ContentFragment.propTypes = {
    breakpointClasses: PropTypes.arrayOf(PropTypes.string),
    fragmentData: PropTypes.shape({}),
    position: PropTypes.string,
    uniqueId: PropTypes.string.isRequired,
};
export default ContentFragment;
//# sourceMappingURL=index.js.map